module.exports = __webpack_public_path__ + "static/media/logo.141bd2b3.png";